import Modal from "@common/Modal";
// import ZeroCrossIcon from "../../../styles/webroot/images/zero-cross.png";
import { useEffect } from "react";
import Lottie from "lottie-react";
import ZeroCrossIcon from "../../../styles/webroot/images/ticTacToe.json";

interface Props {
  show: boolean;
  screenType?: string;
  imageUploadState?: any;
}

export default function UploadImagesPopup({ show, screenType,imageUploadState }: Props) {

    useEffect(() => {
        
    },[imageUploadState?.uploaded])
    
  return (
    <div className="model-outer upload-animation-popup">
    <Modal
      show={show}
      handleClose={() => {}}
      screenType={screenType}
    >
      <div className="modal-header"></div>
      <div className="modal-body">
      <div className="upload-popup">
        <div className="upload-card">
          <div className="icon-wrap">
            {/* <img src={ZeroCrossIcon} alt="Uploading" /> */}
            <div className="animation-outer">
                <Lottie
                animationData={ZeroCrossIcon}
                loop
                autoplay
                style={{ width: 120, height: 120 }}
              />
            </div>
          </div>

          <h2>Keep Calm, Don't press back</h2>

          <p>
            While we are uploading documents on system.
            <br />
            It may take a while..
          </p>

          <div className="upload-txt-dot">{`${imageUploadState?.uploaded}/${imageUploadState?.total} uploaded...`}</div>
        </div>
      </div>
      </div>
    </Modal>
    </div>
  );
}
